import ad0 from "@/assets/reels/ad-engine-works.mp4.asset.json";
import adPoster0 from "@/assets/reels/ad-engine-works.jpg";
import ad1 from "@/assets/reels/ad-green-scene.mp4.asset.json";
import adPoster1 from "@/assets/reels/ad-green-scene.jpg";
import ad2 from "@/assets/reels/ad-nrds.mp4.asset.json";
import adPoster2 from "@/assets/reels/ad-nrds.jpg";
import ad3 from "@/assets/reels/ad-billington.mp4.asset.json";
import adPoster3 from "@/assets/reels/ad-billington.jpg";
import ad4 from "@/assets/reels/ad-dwyer.mp4.asset.json";
import adPoster4 from "@/assets/reels/ad-dwyer.jpg";
import ad5 from "@/assets/reels/ad-optimised-wellbeing.mp4.asset.json";
import adPoster5 from "@/assets/reels/ad-optimised-wellbeing.jpg";
import ad6 from "@/assets/reels/ad-sub86.mp4.asset.json";
import adPoster6 from "@/assets/reels/ad-sub86.jpg";
import ad7 from "@/assets/reels/ad-max-performance.mp4.asset.json";
import adPoster7 from "@/assets/reels/ad-max-performance.jpg";
import reel10 from "@/assets/reels/reel-10.mp4.asset.json";
import reelPoster10 from "@/assets/reels/reel-10.jpg";
import reel11 from "@/assets/reels/reel-11.mp4.asset.json";
import reelPoster11 from "@/assets/reels/reel-11.jpg";
import reel12 from "@/assets/reels/reel-12.mp4.asset.json";
import reelPoster12 from "@/assets/reels/reel-12.jpg";
import reel13 from "@/assets/reels/reel-13.mp4.asset.json";
import reelPoster13 from "@/assets/reels/reel-13.jpg";
import reel14 from "@/assets/reels/reel-14.mp4.asset.json";
import reelPoster14 from "@/assets/reels/reel-14.jpg";
import reel15 from "@/assets/reels/reel-15.mp4.asset.json";
import reelPoster15 from "@/assets/reels/reel-15.jpg";
import reel16 from "@/assets/reels/reel-16.mp4.asset.json";
import reelPoster16 from "@/assets/reels/reel-16.jpg";
import reel1 from "@/assets/reels/reel-1.mp4.asset.json";
import reelPoster1 from "@/assets/reels/reel-1.jpg";
import reel2 from "@/assets/reels/reel-2.mp4.asset.json";
import reelPoster2 from "@/assets/reels/reel-2.jpg";
import reel3 from "@/assets/reels/reel-3.mp4.asset.json";
import reelPoster3 from "@/assets/reels/reel-3.jpg";
import reel4 from "@/assets/reels/reel-4.mp4.asset.json";
import reelPoster4 from "@/assets/reels/reel-4.jpg";
import reel5 from "@/assets/reels/reel-5.mp4.asset.json";
import reelPoster5 from "@/assets/reels/reel-5.jpg";
import reel6 from "@/assets/reels/reel-6.mp4.asset.json";
import reelPoster6 from "@/assets/reels/reel-6.jpg";
import reel7 from "@/assets/reels/reel-7.mp4.asset.json";
import reelPoster7 from "@/assets/reels/reel-7.jpg";
import reel8 from "@/assets/reels/reel-8.mp4.asset.json";
import reelPoster8 from "@/assets/reels/reel-8.jpg";
import reel9 from "@/assets/reels/reel-9.mp4.asset.json";
import reelPoster9 from "@/assets/reels/reel-9.jpg";
// Single source of truth for site-wide static content.
export const CLIENTS: { name: string; placeholder?: boolean }[] = [
  { name: "Scott Risk Management" },
  { name: "ScottRM Genie" },
  { name: "Dwyer Construction" },
  { name: "Sub86" },
  { name: "Moneypenny" },
  { name: "The Engine Works" },
  { name: "Xgas" },
  { name: "The Iron Forge" },
  { name: "Nigel Richards Driving School" },
  { name: "Optimised Wellbeing" },
  { name: "Billington Autos" },
  { name: "Green Scene Group", placeholder: true },
  { name: "The Engine Works", placeholder: true },
];


export const PROCESS = [
  { title: "Discovery call", text: "A quick chat about your business, your customers and what a good month looks like." },
  { title: "Content plan", text: "We plan every video around what makes people pick up the phone." },
  { title: "Filming day", text: "One shoot day on site. We handle the kit, the direction and the awkward bits." },
  { title: "Edit and launch", text: "Videos edited for social, ads built and pushed live to the right local people." },
  { title: "Optimise and grow", text: "We track the leads, keep what works and cut what doesn't. Every month." },
];

export const REVIEWS = [
  { name: "J. Rogers", quote: "Working with Stag Marketing Group has been a pleasure. We're already looking forward to extending our work with them." },
  { name: "G. Williams", quote: "Stag Marketing Group has been incredible to work with. Professional, creative and results driven." },
  { name: "C. Hedderick", quote: "Amazing service and great results. I would highly recommend Stag Marketing Group!" },
  { name: "R. Miah", quote: "Working alongside Stag was incredible. Clear communication, great energy, and a team that truly knows what they're doing." },
  { name: "A. Stanaway", quote: "Excellent experience. Strategic execution resulted in immediate increase in leads and engagement." },
  { name: "J. Veail", quote: "Totally personal experience from start to finish. World class service." },
  { name: "P. Seager", quote: "Awesome service. Delivered on time and exceeded expectations." },
  { name: "J. Cook", quote: "Clear communication and worked with my ideas to deliver exactly what I wanted." },
  { name: "A. Cutsforth", quote: "Working with the Stag Marketing team was fantastic. Super personalised experience and excellent results!" },
  { name: "C. Evans", quote: "Brilliant website design. Simple process and great results. Highly recommend!" },
  { name: "J. Sargent", quote: "Had a website designed that was absolutely fantastic! Huge shout out to the stag team!" },
  { name: "M. Powell", quote: "Our website and branding have been done to a great standard, can't recommend the company enough!" },
  { name: "F. Lewis", quote: "The lads at Stag are great! Had our website live within weeks. Quick to respond and full of great ideas." },
  { name: "M. Drinkwater", quote: "I recently worked with Stag on building my website and I'm genuinely impressed from start to finish." },
  { name: "H. Ramsay", quote: "Absolutely worth every penny. Professional, attentive, and genuinely skilled in design and marketing. The final result is beautiful." },
];


export type VideoItem = {
  id: string;
  title: string;
  category: "Lead generation" | "Company profile" | "Testimonial" | "Advert" | "Website video" | "Brand content";
  /** YouTube video ID, or a direct video file URL in `src` */
  youtubeId?: string;
  src?: string;
  poster?: string;
};

// Swap placeholders for real clips. Use a YouTube ID or a compressed MP4 URL.
export const PORTFOLIO: VideoItem[] = [
  { id: "aarons", title: "Aaron's Gutter Cleaning company profile", category: "Company profile", youtubeId: "mEGNpN6j-Yw" },
  { id: "mbec", title: "MBEC website video", category: "Website video", youtubeId: "lxtQ9Su2SUE" },
  { id: "p1", title: "Lead generation ad", category: "Lead generation" },
  { id: "p2", title: "Customer testimonial", category: "Testimonial" },
  { id: "p3", title: "Local advert", category: "Advert" },
  { id: "p4", title: "Website video", category: "Website video" },
];

// Vertical 9:16 social clips. Add MP4 URLs and posters.
export const REELS: { id: string; src?: string; poster?: string; label: string }[] = [
  { id: "r16", src: reel16.url, poster: reelPoster16, label: "Stag reel 16" },
  { id: "r10", src: reel10.url, poster: reelPoster10, label: "Stag reel 10" },
  { id: "r11", src: reel11.url, poster: reelPoster11, label: "Stag reel 11" },
  { id: "r12", src: reel12.url, poster: reelPoster12, label: "Stag reel 12" },
  { id: "r13", src: reel13.url, poster: reelPoster13, label: "Stag reel 13" },
  { id: "r14", src: reel14.url, poster: reelPoster14, label: "Stag reel 14" },
  { id: "r15", src: reel15.url, poster: reelPoster15, label: "Stag reel 15" },
  { id: "r1", src: reel1.url, poster: reelPoster1, label: "Stag reel 1" },
  { id: "r2", src: reel2.url, poster: reelPoster2, label: "Stag reel 2" },
  { id: "r3", src: reel3.url, poster: reelPoster3, label: "Stag reel 3" },
  { id: "r4", src: reel4.url, poster: reelPoster4, label: "Stag reel 4" },
  { id: "r5", src: reel5.url, poster: reelPoster5, label: "Stag reel 5" },
  { id: "r6", src: reel6.url, poster: reelPoster6, label: "Stag reel 6" },
  { id: "r7", src: reel7.url, poster: reelPoster7, label: "Stag reel 7" },
  { id: "r8", src: reel8.url, poster: reelPoster8, label: "Stag reel 8" },
  { id: "r9", src: reel9.url, poster: reelPoster9, label: "Stag reel 9" },
];


// Lead gen ads with sound. Vertical 9:16, click to play.
export const ADS: { id: string; client: string; src: string; poster: string }[] = [
  { id: "engine-works", client: "The Engine Works", src: ad0.url, poster: adPoster0 },
  { id: "green-scene", client: "Green Scene Group", src: ad1.url, poster: adPoster1 },
  { id: "nrds", client: "Nigel Richards Driving School", src: ad2.url, poster: adPoster2 },
  { id: "billington", client: "Billington Autos", src: ad3.url, poster: adPoster3 },
  { id: "dwyer", client: "Dwyer Construction", src: ad4.url, poster: adPoster4 },
  { id: "optimised-wellbeing", client: "Optimised Wellbeing", src: ad5.url, poster: adPoster5 },
  { id: "sub86", client: "Sub86 Ice Blasting", src: ad6.url, poster: adPoster6 },
  { id: "max-performance", client: "Max Performance", src: ad7.url, poster: adPoster7 },
];

export const HERO_VIDEO = { src: "", poster: "" }; // [VIDEO URL HERO] compressed MP4 + poster
export const SHOWREEL = { youtubeId: "lxtQ9Su2SUE" }; // [SHOWREEL VIDEO] replace with your showreel


import { LOCATIONS, type LocationSlug } from "./content";
export * from "./content";

const TOWN_TO_LOCATION: Record<string, LocationSlug> = {
  wrexham: "videographer-wrexham", chirk: "videographer-llangollen", llangollen: "videographer-llangollen", "st-martins": "videographer-shropshire",
  "north-wales": "videographer-north-wales", mold: "videographer-mold", flintshire: "videographer-north-wales", deeside: "videographer-deeside",
  broughton: "videographer-north-wales", buckley: "videographer-north-wales", ruthin: "videographer-north-wales", denbigh: "videographer-north-wales",
  "st-asaph": "videographer-north-wales", chester: "videographer-chester",
  shrewsbury: "videographer-shrewsbury",
  oswestry: "videographer-oswestry", whitchurch: "videographer-whitchurch", "market-drayton": "videographer-shropshire", ellesmere: "videographer-shropshire",
  bridgnorth: "videographer-shropshire", telford: "videographer-telford", welshpool: "videographer-shropshire", newtown: "videographer-shropshire",
};
const SECONDARY = ["website-design", "web-design", "graphic-design", "graphics-design", "content-creation", "marketing-collateral", "marketing-strategy", "social-media"];

/** Map a removed URL to its closest live page. Returns null if no rule applies. */
export function resolveRedirect(path: string): string | null {
  const p = path.toLowerCase().replace(/\/+$/, "") || "/";
  const fixed: Record<string, string> = {
    "/contact": "/#contact", "/book-call": "/#contact", "/get-started": "/#contact", "/thank-you-call": "/thank-you",
    "/packages": "/video-growth-engine", "/careers": "/about", "/sitemap": "/", "/news-archive": "/",
    "/video-production": "/commercial-video", "/login": "/",
    "/case-study/mbec": "/our-results", "/case-study/maxperformance": "/our-results", "/our-results/max-performance": "/our-results",
  };
  if (fixed[p]) return fixed[p];
  if (p === "/our-work" || p.startsWith("/our-work/")) return p.replace("/our-work", "/our-results");
  if (p.startsWith("/admin") || p.startsWith("/news/")) return "/";
  if (p.startsWith("/case-study/") || p.startsWith("/our-results/")) return "/our-results";
  const m = p.match(/^\/(video-production|[a-z-]+?)-(.+)$/);
  if (p.startsWith("/video-production-") && m) return TOWN_TO_LOCATION[m[2]] ? `/${TOWN_TO_LOCATION[m[2]]}` : "/commercial-video";
  for (const s of SECONDARY) if (p === `/${s}` || p.startsWith(`/${s}-`)) return "/other-services";
  return null;
}
